import { FC } from "react";
import { Button, Icon } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

import { SbpIcon } from "../../../../icons";
import { RoutesMap } from "../../../../../routes.tsx";
import { isStringWithNumber } from "../../../../../utils";
import { useGetLimitQuery } from "../../../../../api/limit";
import { useSbpTransferStore } from "../../../../../store/sbpTransferStore.ts";
import { useSbpTransferScheduleQuery } from "../../../../../api/sbpTransfer/hooks";
import { MIN_SBP_TRANSFER_AMOUNT } from "../SbpTransferPageAmountWithTerm/SbpTransferPageAmount";

export const SbpTransferPageButton: FC = () => {
  const { data: limit } = useGetLimitQuery();
  const { isFetching: isScheduleFetching } = useSbpTransferScheduleQuery();

  const amount = useSbpTransferStore(s => s.amount);
  const term = useSbpTransferStore(s => s.term);

  const availableLimit = isStringWithNumber(limit?.cashBalance) ? Number(limit?.cashBalance) : 0;

  const isDisabled
      = !availableLimit
      || !term
      || Number(amount) < MIN_SBP_TRANSFER_AMOUNT
      || Number(amount) > availableLimit
      || isScheduleFetching;

  return (
    <Button
      as={RouterLink}
      to={RoutesMap.sbpTransfer.banks}
      mt="24px"
      colorScheme="brand"
      isDisabled={isDisabled}
    >
      Перевести

      <Icon as={SbpIcon} w="14px" h="17px" ml="7px" isDisabled={isDisabled} />
    </Button>
  );
};
